<div class="grid grid-cols-1 gap-2 px-2" *ngIf="comments">
    <div *ngFor="let comment of commentsArray; trackBy: trackByFn" class="flex">
        <div class="pr-2">
            <avatar-component class="my-1" [name]="getUsername(comment)"></avatar-component>
        </div>

        <div class="flex-1">
            <div class="border rounded-2xl p-3 bg-accent-50">
                <div>
                    {{ comment.content }}
                </div>
                <div class="text-right text-xs text-primary-300" *ngIf="comment.created_at">
                    {{ comment.created_at | date : "short" }}
                </div>
            </div>
            <div class="mt-2">
                <app-communication-comment [comments]="comment.children" [users]="users">
                </app-communication-comment>
            </div>
            <div class="flex">
                <div class="ml-4 mt-1 text-secondary w-full">
                    <span class="cursor-pointer hover:underline" *ngIf="canReply(comment)" (click)="toggleReplyMode()">Répondre</span>
                    <app-communication-input *ngIf="isReplyOpen(comment)" (send)="sendReply($event, comment)"></app-communication-input>
                </div>
            </div>
        </div>


    </div>

</div>
